import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cygnus_token');
    const savedUser = localStorage.getItem('cygnus_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        const savedTenant = localStorage.getItem('cygnus_tenant');
        if (savedTenant) setTenant(JSON.parse(savedTenant));
      } catch (e) {
        localStorage.clear();
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await authAPI.login(email, password);
    const { access_token, user: userData, tenant: tenantData } = res.data;
    localStorage.setItem('cygnus_token', access_token);
    localStorage.setItem('cygnus_user', JSON.stringify(userData));
    localStorage.setItem('cygnus_tenant', JSON.stringify(tenantData));
    setUser(userData);
    setTenant(tenantData);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('cygnus_token');
    localStorage.removeItem('cygnus_user');
    localStorage.removeItem('cygnus_tenant');
    setUser(null);
    setTenant(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, tenant, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
